import {useEffect, useLayoutEffect, useState} from "react";
import {GetAllServiceType} from "../../../../../reduxToolkit/ServiceType/ServiceTypeApi";
import {toast} from "react-toastify";
import routes from "../../../../../Routes/routes";
import {Supplier} from "../../../../../models/Supplier";
import { GetEmployeeSupplierByItId,
    UpdateSupplier
} from "../../../../../reduxToolkit/EmployeeProviders/EmployeeProvidersApi";
import {getPhotoPicker, PHOTO_PICKER_MODEL} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import {errorMsg, isEmailFormat, isPhoneFormat, isValidLengthDocumentId} from '../../../../../Apis/functions';
import {useLocation} from "react-router-dom";
import IconPersonDefault from "../../../../../assets/ImagesDefaults/ic-person-v2.svg";
import { GetSingleUserProvider } from "../../../../../reduxToolkit/Providers/providersApi";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const EmployeeFlowSupplierUpdateApp = (
    {
        t,
        params,
        dispatch,
        navigate,
        permission,
        setEmptyFields,
        isValidDob,
        isValidPassword,
        photoPicker,
        setSecretModal,
        setSecretKey,
        setSteps,
        modified,
        setModified,
        setPhotoPicker,
        setIsValidDocumentId,
        isValidDocumentId,

    }
) => {
    const location = useLocation();
    let { state } = location;
    const [getAllServiceType, setGetAllServiceType] = useState([])
    const [user, setUser] = useState({...Supplier});
    const [showUnlinkBtn, setShowUnlinkBtn] = useState(false);

    useLayoutEffect(() => {
        setSteps([t("company_details"), t("manager_details"), t("photo")]);
    }, [permission, t]);

    useEffect(() => {
        dispatch(GetAllServiceType()).then(({payload: {data: {data}}}) => {
            setGetAllServiceType(data)
        });
    }, [dispatch])

    // Form handeler Function
    const FormHandler = () => {
        const emailOk = isEmailFormat(user.email);
        const phoneOk = isPhoneFormat(user.phoneNumber);

        if (!user.isValid() ||
            !isValidDob ||
            !phoneOk ||
            !emailOk ||
            !isValidPassword 
        ) {
            toast.warn(t('please_fill_all_fields'));
            setEmptyFields(true)
        } else {
            setEmptyFields(false);
            updateSupplier();
        }
    };

    const updateSupplier = () => {
        let imageFile = getPhotoPicker(photoPicker);
        const addPw = user?.password?.trim() !== '' && user?.password !== null;

        dispatch(UpdateSupplier({
            data: user.toCreateUpdate(addPw ? user?.password.trim() : null),
            file: imageFile,
            updateImage: user.selfie !== null,
            setModified: setModified
        }),).then(({payload: {data: { data, success, code}}}) => {
            if (success) {
                if(data?.secret && addPw ){
                    setSecretModal(true);
                    setSecretKey(data?.secret)
                }
                toast.success(t('has_been_updated_successfully'));
                setEmptyFields(false);

            } else {
                errorMsg(code)
                setEmptyFields(true);
            }
        });
    }

    useEffect(() => {
        getSupplierInfo();
    }, []);

    useEffect(() => {
        if(modified){
            getSupplierInfo();
            setModified(false);
        }
    }, [modified]);

    const getSupplierInfo = () => {
        dispatch(GetEmployeeSupplierByItId(params?.id)).then(
            ({
                payload: {
                    data: { success, data },
                },
            }) => {
                if (success === true) {
                    const deviceId = data?.deviceId ?? null;
                    setUser((prevData) => ({
                        ...prevData,
                        ...data,
                    }));
                    
                    setShowUnlinkBtn(!!deviceId);
                    if (data?.selfie)
                        setPhotoPicker({
                            ...PHOTO_PICKER_MODEL,
                            previewImage: `data:image/jpeg;base64,${data?.selfie}`,
                            preview: IconPersonDefault,
                        });
                }
            },
        );
    };

    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl, {
                state: { currentTab: state?.currentTab}
            });
        } else {
            navigate(routes.suppliers.main)
        }
    }

    return {
        user,
        setUser,
        FormHandler,
        getAllServiceType,
        goBack,
        showUnlinkBtn
    };
}
